import { render, staticRenderFns } from "./ReceivePayment.vue?vue&type=template&id=5ff3dbf8&scoped=true"
import script from "./ReceivePayment.vue?vue&type=script&lang=js"
export * from "./ReceivePayment.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ff3dbf8",
  null
  
)

export default component.exports